import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Saveable } from '®shared/data';

export const STATE_FEATURE_TALIS_ENGAGE_SETTINGS = 'talis-engage-settings';

export interface TalisEngageSettings {
  talisReaderWorkflowEnabled: boolean;
  requireAllUploadedFilesToBeCleared: boolean;
}

export interface SaveableTalisEngageSettingsState
  extends Saveable,
    TalisEngageSettings {
  isSaved?: boolean;
}

export interface TalisEngageSettingsState {
  talisEngageSettings: SaveableTalisEngageSettingsState | null;
}

export const TALIS_ENGAGE_SETTINGS_INITIAL_STATE: TalisEngageSettingsState = {
  talisEngageSettings: null,
};

export function getInitialTalisEngageSettingsState(): TalisEngageSettingsState {
  return TALIS_ENGAGE_SETTINGS_INITIAL_STATE;
}

export const selectTalisEngageSettingsState =
  createFeatureSelector<TalisEngageSettingsState>(
    STATE_FEATURE_TALIS_ENGAGE_SETTINGS,
  );

export const selectTalisEngageSettings = createSelector(
  selectTalisEngageSettingsState,
  state => state.talisEngageSettings,
);

export enum TalisEngageSettingsTier {
  TADC = 'tadc',
  DCS = 'dcs',
  BASIC = 'basic',
  GET_IN_TOUCH = 'getintouch',
  HIDE = 'hide',
}
